module.exports = __webpack_public_path__ + "static/media/ng-post-bot.dd780f7f.png";